export const FixedComponentsRateChartRequestColumns = [
    "SNo",
    "ElectricityCost",
    'FuelCost', 
    'Consumables',
    'QCCost',
    'RepairAndMaintenance',
    'EmployeeCost',
    'FinanceCost' ,
    'AssetDepreciationCost'
]